import './BuildAllPracticeExamModal.css';

import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

export default class BuildAllPracticeExamModal extends React.Component {
  handleBuildAllButtonPress = () => {
    this.props.buildAllExams();
    this.props.toggle();
  };

  render() {
    const { isOpen, toggle } = this.props;
    return (
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader>Build All</ModalHeader>

        <ModalBody>
          <div className="build-all-modal-form">
            <p>
              This builds the missing weekly practice exams for every rating
              exam of the <strong>active cycles</strong>. Exams that already
              have one for this week are left untouched.
            </p>
          </div>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={() => this.handleBuildAllButtonPress()}
          >
            Build All
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
